import React from 'react';
import { Spinner } from 'reactstrap';

const Loader = () => {
    return (
        <div className="position-relative clearfix" style={{ minHeight: "36px" }}>
            <div className="d-flex justify-content-center">
                <Spinner color="primary">Loading... </Spinner>
            </div>
        </div>
    );
};

export default Loader;